import React, { useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler';
import {ReactComponent as WrapArrow} from '../../assets/wrap-arrow.svg';
// import WrapArrow from '../../assets/wrap-arrow.svg';

export const WrapWindow = ({title, showScroll=false, minWidth = '340px', maxWidth = '340px', subtitle, body, footer, style = {}}) => {
    const [isOpened, setOpen] = useState(false);
    const closeDebtsHandler = () => {
        if (!isOpened) return;
        setOpen(false);
    }

    return (
        <OutsideClickHandler onOutsideClick={closeDebtsHandler}>
          <div className={`wrap-window dark-theme-bg0 ${isOpened ? 'opened' : ''}`} style={{minWidth, maxWidth}}>
            <div className="wrap-window__header">
              <div className="wrap-window__title">{title}</div>
              {subtitle && <div className="wrap-window__subtitle">{subtitle}</div>}
            </div>
            <div className={`wrap-window__body ${showScroll ? 'show-scroll':''}`} style={style}>
                {body}
            </div>
            <div className="wrap-window__footer">
                {footer}
            </div>
            <div className="wrap-button dark-theme-bg1" onClick={() => setOpen(prev => !prev)}>
                <WrapArrow width="16px" height="16px" />
            </div>
        </div>
          </OutsideClickHandler>
    );
}
